import React, { useState, useEffect } from "react";
import "./MobileDatePicker.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/mobile.css";

export default function MobileDatePicker(props) {
  const [selectedDate, setSelectedDate] = useState("");
  const [dateText, setDateText] = useState("");

  useEffect(() => {
    const JalaliMoment = require("jalali-moment");
    const dateString = props.date;
    const [year, month, day] = dateString.split("-");
    const jalaliDate = JalaliMoment(
      `${year}-${month}-${day}`,
      "jYYYY-jMM-jDD"
    ).locale("fa");
    const monthName = jalaliDate.format("jMMMM");
    const weekdayName = jalaliDate.format("dddd");
    setDateText(`${weekdayName} ${day} ${monthName} ${year}`);
  }, []);

  useEffect(() => {
    if (props.date) {
      setSelectedDate(props.date);
    } else {
      const JalaliMoment = require("jalali-moment");
      const today = JalaliMoment().locale("fa");
      const year = today.jYear();
      const month = today.jMonth() + 1;
      const day = today.jDate();
      setSelectedDate(`${year}-${month}-${day}`);
      const monthName = today.format("jMMMM");
      const weekdayName = today.format("dddd");
      setDateText(`${weekdayName} ${day} ${monthName} ${year}`);
    }
  }, [props.date]);

  const handleDateChange = (e) => {
    const { year, month, day } = e;
    const weekdayName = e.weekDay.name;
    const monthName = e.month.name;
    const date = `${year}-${month}-${day}`;
    const text = `${weekdayName} ${day} ${monthName} ${year}`;
    setSelectedDate(date);
    setDateText(text);
  };

  const closeDatePicker = () => {
    props.onClose();
  };

  const sendSelectedDate = () => {
    closeDatePicker();
    props.onSend(selectedDate);
  };

  const setTodayDate = () => {
    const JalaliMoment = require("jalali-moment");
    const today = JalaliMoment().locale("fa");
    const year = today.jYear();
    const month = today.jMonth() + 1;
    const day = today.jDate();
    setSelectedDate(`${year}-${month}-${day}`);
    const monthName = today.format("jMMMM");
    const weekdayName = today.format("dddd");
    setDateText(`${weekdayName} ${day} ${monthName} ${year}`);
  };
  return (
    <>
      <div
        className="datePickerOverlay centeredFlex"
        onClick={closeDatePicker}
      ></div>
      <div
        className="datePicker"
        style={
          props.label === "calorie" ? { bottom: "3.8rem" } : { bottom: "0" }
        }
      >
        {selectedDate && <h3 className="selectedDate">{dateText}</h3>}
        <div className="datepickerContent centeredFlex">
          {selectedDate && (
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-center"
              value={selectedDate}
              onChange={handleDateChange}
              inputClass="customDatePickerInput"
              className="rmdp-mobile"
            />
          )}
        </div>
        <div className="datePickerBtns centeredFlex">
          <button className="confirmDate" onClick={setTodayDate}>
            امروز
          </button>
          <div className="datePickerBtnsLeft centeredFlex">
          <button className="cancelDate" onClick={closeDatePicker}>
            انصراف
          </button>
          <button className="confirmDate" onClick={sendSelectedDate}>
            تایید
          </button>
          </div>
          
        </div>
      </div>
    </>
  );
}
